import {Person_Stroke2_Corner0_Rounded as PersonIcon} from '#/components/icons/Person'
import {School_Stroke2_Corner0_Rounded as InstitutionIcon} from '#/components/icons/School'
import {type OwnerKindIcon} from '#/state/classrooms/account'

/**
 * The drawing a row wears for the account behind a classroom.
 *
 * Two drawings, and two is the whole of it: the app's account vocabulary holds
 * forty kinds — a primary school, a university, a library, a mosque school; a
 * tutor, a coach, a podcaster — and a menu row is one line icon at one size.
 * Forty of those do not tell themselves apart at twenty points, so the icon
 * answers the one question a glance can carry — **is this an institution or a
 * person?** — and everything finer is the row's words, which is the half a reader
 * can actually use (`readOwnerKind`: *Primary School*, *Coach*).
 *
 * The institution is drawn with the app's own school (`School_Stroke2_...`), the
 * building with a gable and a door, because a classroom is a room in one and the
 * line icon is what every row beside it uses; the person with the app's plain
 * person, the same one a profile's own row is drawn with. Neither is an emoji:
 * the account kinds wear emoji under a profile's handle and in a post's byline
 * (`ORG_TYPE_ICONS`), where there is room for colour and a glyph per kind, and a
 * menu row has neither.
 */
export function ownerKindIcon(
  kind: OwnerKindIcon,
): typeof PersonIcon | typeof InstitutionIcon {
  return kind === 'organisation' ? InstitutionIcon : PersonIcon
}
